import { getItemFromCollection } from "directus/src/operations";

export async function fetchEntityDataforForm({ id }) {
    try {
        const query = {
            fields: [
                "id",
                "name",
                "status",
                "organisation.id",
                "organisation.name",
            ],
        };

        const response = await getItemFromCollection("legal_entities", id, query);
        return response;
    } catch (error) {
        console.error(error);

        throw error;
    }
}
